// extracted by mini-css-extract-plugin
export default {"app":"App_app__kjqwC","title":"App_title__TSMio","contentContainer":"App_contentContainer__2Zgdh","mobileTitle":"App_mobileTitle__5DA9j"};